import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { FileBase } from './file-base';

@Component({
	selector: 'file-uploader',
	template: require('./file-uploader.component.html')
})
export class FileUploaderComponent extends FileBase implements OnInit{

	constructor() { super(); }

	uploader: FileUploader;

	@ViewChild('browseButton') browseButton: ElementRef;

	@Output('fileUploaded') fileUploaded = new EventEmitter();

	@Input('uploadUrl')
	set uploadUrl(value: string) {
		this.uploader = new FileUploader({ url: value, autoUpload: true });
		this.uploader.onCompleteItem = (fileItem: any, response: any) => {
			console.dir({ fileItem, response });
			this.fileUploaded.emit(fileItem);
		};
	}

	ngOnInit() { }


	get message() {

		if (!this.uploader) {
			return "Idle";
		}

		if (this.uploader.isUploading) {
			return "Uploading ...";
		} else {
			return "Upload drop zone";
		}
	}

	hasBaseDropZoneOver: boolean = false;

	fileOverBase = (e: any): void => this.hasBaseDropZoneOver = e;

	onBrowseClick = (): void => this.browseButton.nativeElement.click();

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/file-uploader.component.ts